export const ADD_ERROR = "ADD_ERROR";
export const UPDATE_CACHE = "UPDATE_CACHE";
export const DELETE_FROM_CACHE = "DELETE_FROM_CACHE";